/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { FunctionComponent } from 'react';
import { Box, Text } from '@wix/design-system';
import css from './index.module.scss';
import { ArticleSortType } from '@wix/answers-api';
import { RoadmapLabelsList } from '../RoadmapLabelsList';
import { RoadmapFeatureResolution, RoadmapFilterType } from '../../types';
import RoadmapMobileSortAndFilterMenu from '../RoadmapArticleList/RoadmapMobileSortAndFilterMenu';

export type RoadmapActionProps = {
  selectedLabel: {
    id: string;
    name: string;
  };
  labels: {
    id: string;
    name: string;
  }[];
  resolution: RoadmapFeatureResolution;
  filterType: RoadmapFilterType;
  sortType: ArticleSortType;
  applyValue: (
    filter: RoadmapFilterType,
    sort: ArticleSortType,
    resolution?: RoadmapFeatureResolution
  ) => void;

  onSelectLabel: (label: { id: string; name: string }) => void;
};

export const RoadmapAction: FunctionComponent<RoadmapActionProps> = ({
  selectedLabel,
  labels,
  onSelectLabel,
  resolution,
  filterType,
  sortType,
  applyValue,
}: RoadmapActionProps) => {
  const selectedLabelHeader = (
    <Text className={css.selectedLabelTitle}>{selectedLabel.name}</Text>
  );

  return (
    <Box className={css.RoadmapAction}>
      <Box width={'100%'}>
        <RoadmapLabelsList
          labels={labels}
          selectedLabel={selectedLabel}
          onSelectLabel={onSelectLabel}
        />
        {selectedLabelHeader}
      </Box>
      <RoadmapMobileSortAndFilterMenu
        articleResolution={resolution}
        filterType={filterType}
        sortType={sortType}
        applyValue={applyValue}
      />
    </Box>
  );
};
